var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPopUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 512 512"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M81 260v179h358v-94h-35l-.2 29.2-.3 29.3-143.2.3-143.3.2V117h58V81H81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M260 99v18h117.5L270.2 224.3C211.3 283.2 163 332 163 332.5c0 .6 5.5 6.5 12.3 13.3l12.2 12.2L295 250.5C354.1 191.4 402.8 143 403.2 143c.5 0 .8 26.3.8 58.5V260h35V81H260z"
}))));
export default SvgPopUp;